/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_PeerInputs */

const th_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้เข้าร่วมอีกคน`)
};

const en_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other participant`)
};

const ja_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手`)
};

const zh_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`另一个人`)
};

const es_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro participante`)
};

const pt_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro participante`)
};

const id_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orang lain`)
};

const fr_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre participant`)
};

const tl_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabilang tao`)
};

const vi_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người kia`)
};

const ko_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상대방`)
};

const de_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Person`)
};

const ru_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Второй участник`)
};

const tr_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer kişi`)
};

const it_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'altra persona`)
};

const pl_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druga osoba`)
};

const uk_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Друга людина`)
};

const hi_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दूसरा व्यक्ति`)
};

const ar_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشخص الآخر`)
};

const ms_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orang satu lagi`)
};

const bn_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্য জন`)
};

const zh_tw2_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`另一個人`)
};

const zh_hk2_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`另一個人`)
};

const ur_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوسرا شخص`)
};

const fa_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نفر دیگر`)
};

const sw_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mtu mwingine`)
};

const nl_meeting_test_peer = /** @type {(inputs: Meeting_Test_PeerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De ander`)
};

/**
* | output |
* | --- |
* | "Other participant" |
*
* @param {Meeting_Test_PeerInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_peer = /** @type {((inputs?: Meeting_Test_PeerInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_PeerInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_peer(inputs)
	if (locale === "ja") return ja_meeting_test_peer(inputs)
	if (locale === "zh") return zh_meeting_test_peer(inputs)
	if (locale === "es") return es_meeting_test_peer(inputs)
	if (locale === "pt") return pt_meeting_test_peer(inputs)
	if (locale === "id") return id_meeting_test_peer(inputs)
	if (locale === "fr") return fr_meeting_test_peer(inputs)
	if (locale === "tl") return tl_meeting_test_peer(inputs)
	if (locale === "vi") return vi_meeting_test_peer(inputs)
	if (locale === "ko") return ko_meeting_test_peer(inputs)
	if (locale === "de") return de_meeting_test_peer(inputs)
	if (locale === "ru") return ru_meeting_test_peer(inputs)
	if (locale === "tr") return tr_meeting_test_peer(inputs)
	if (locale === "it") return it_meeting_test_peer(inputs)
	if (locale === "pl") return pl_meeting_test_peer(inputs)
	if (locale === "uk") return uk_meeting_test_peer(inputs)
	if (locale === "hi") return hi_meeting_test_peer(inputs)
	if (locale === "ar") return ar_meeting_test_peer(inputs)
	if (locale === "ms") return ms_meeting_test_peer(inputs)
	if (locale === "bn") return bn_meeting_test_peer(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_peer(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_peer(inputs)
	if (locale === "ur") return ur_meeting_test_peer(inputs)
	if (locale === "fa") return fa_meeting_test_peer(inputs)
	if (locale === "sw") return sw_meeting_test_peer(inputs)
	if (locale === "nl") return nl_meeting_test_peer(inputs)
	return en_meeting_test_peer(inputs)
});